import * as React from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import download from 'downloadjs';
import { paymentsActionTypes } from '../payments-action-types';
import { getFormattedDate } from '../../../utils/utilities';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { IPaymentsAction } from '../payments-interfaces';
import { GET } from '../../store-helper';
import { ITransactionsPaginationData } from '../payments-interfaces-helper';
import { ITransactionsFilters } from '../../../components/transactions/TransactionsPageFilter';

export const fetchTransactionsData = async (searchParams: ITransactionsFilters): Promise<ITransactionsPaginationData> => {

  try {

    return await GET({
      pathname: `${BASE_URL.PAYMENTS}/transactions`,
      params: searchParams,
    });

  } catch (e) {
    sendSentryMessage({ name: `GET Fetch transactions data error`, context: e });
    console.log(e);
  }
};

interface IExportCSVTransactionsDataProps {
  dispatch: React.Dispatch<IPaymentsAction>,
  dateFilterState: [string | Date, string | Date],
  size: number,
}

export const exportCSVTransActionsData = async ({ dispatch, dateFilterState, size }: IExportCSVTransactionsDataProps): Promise<void> => {
  dispatch({ type: paymentsActionTypes.SET_EXPORT_CSV_LOADING, payload: true });
  try {
    const from = dateFilterState[0] ? getFormattedDate(dateFilterState[0], 'yyyy-MM-dd') : undefined;
    const to = dateFilterState[1] ? getFormattedDate(dateFilterState[1], 'yyyy-MM-dd') : undefined;
    const params = {
      pageSize: size,
      pageNumber: 1,
      from,
      to,
      responseType: 'blob'
    };

    const res = await axios(`${BASE_URL.PAYMENTS}/transactions/export`, { params });

    if (res.data) {
      const blob = new Blob([res.data], { type: 'text/csv' });
      download(blob, 'Transactions.csv');
    }

    dispatch({ type: paymentsActionTypes.SET_EXPORT_CSV_LOADING, payload: false });
  } catch (e) {
    console.log(e);
    dispatch({ type: paymentsActionTypes.SET_EXPORT_CSV_LOADING, payload: false });
  }
};
